import React from 'react';
import Icon from 'react-icons-kit';
import {ic_arrow_drop_up as ArrowUp} from 'react-icons-kit/md/ic_arrow_drop_up';
import {ic_arrow_drop_down as ArrowDown} from 'react-icons-kit/md/ic_arrow_drop_down';
import PropTypes from "prop-types";

const SortColumn = (props) => {

    let icon;
    switch (props.order){
        case "asc":
            icon = ArrowUp;
            break;
        case "desc":
            icon = ArrowDown;
            break;
    }

    return <div style={{ cursor: "pointer" }} onDoubleClick={() => {

        if(props.onChange && props.order != null){
            props.onChange(null);
        }

    }} onClick={() => {

        if(props.onChange) {

            let cOrder;
            switch (props.order){
                case "asc":
                    cOrder = "desc";
                    break;
                case "desc":
                    cOrder = "asc";
                    break;
                default:
                    cOrder= "asc";
            }

            props.onChange(cOrder);
        }

    }}>{(props.isActive && icon) && <Icon icon={icon}/>} {props.label}</div>;

};

SortColumn.propTypes = {
    isActive: PropTypes.bool,
    order: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    removeOnDblClick: PropTypes.bool
};

SortColumn.defaultProps = {
    removeOnDblClick: true
};

export default SortColumn;


// WEBPACK FOOTER //
// ./src/common/SortColumn.js